/* global appData */

function sendMessageToParent(event, detail = {}) {
	parent.postMessage({ event, detail }, `${appData.appPath}`);
}

export default sendMessageToParent;
